import React from 'react';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonButton,
  IonRow,
  IonCol,
  IonImg,
  IonIcon
} from '@ionic/react';

import './Password.css';
import { camera, image, cloudUpload } from 'ionicons/icons';

const Photo: React.FC = () => {

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>Mi perfil</IonTitle>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonRow class="ion-padding-top">
          <IonCol className="ion-align-self-start" size="2"></IonCol>
          <IonCol className="ion-align-self-center">
            <IonImg src="assets/img/profile.png"/>
          </IonCol>
          <IonCol className="ion-align-self-end" size="2"></IonCol>
        </IonRow>
          <div className="ion-padding">
            <IonButton expand="block" type="submit" className="ion-no-margin"><IonIcon icon={camera} />&nbsp;Tomar foto</IonButton>
          </div>
          <div className="ion-padding">
            <IonButton expand="block" type="submit" className="ion-no-margin"><IonIcon icon={image} />&nbsp;Seleccionar imagen</IonButton>
          </div>
          <div className="ion-padding">
            <IonButton color="medium" expand="block" type="submit" className="ion-no-margin"><IonIcon icon={cloudUpload} />&nbsp;Subir imagen</IonButton>
          </div>
       
      </IonContent>
    </IonPage>
  );
};

export default Photo;
